import {
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';

import { EmptyBoxIcon } from '@/components/icons';

import { CartItem } from './cart-item.component';
import { useCart } from './cart.hook';

export const CartItems = () => {
    const { activeCart, isActiveCartFetching, isActiveCartLoading } = useCart();

    const isLoading = isActiveCartLoading || isActiveCartFetching;
    const items = activeCart?.data?.items || [];

    const renderItems = () => {
        if (isLoading) {
            return (
                <TableRow>
                    <TableCell colSpan={6} className="text-center">
                        Loading...
                    </TableCell>
                </TableRow>
            );
        }

        if (!items.length) {
            return (
                <TableRow>
                    <TableCell colSpan={6} className="">
                        <div className="flex flex-col items-center justify-center space-y-2 py-4 text-center text-sm text-gray-500">
                            <EmptyBoxIcon />
                            <span className="block">
                                No items in the cart. <br /> Please add some
                                products to the cart.
                            </span>
                        </div>
                    </TableCell>
                </TableRow>
            );
        }

        return items.map((item) => <CartItem key={item.id} item={item} />);
    };

    return (
        <Card>
            <CardContent className="cart-items-list overflow-hidden px-0 py-0">
                <Table className="relative">
                    <TableHeader className="sticky top-0 h-[50px] bg-slate-50">
                        <TableRow>
                            <TableHead>Medicine Name</TableHead>
                            <TableHead className="text-right">Price</TableHead>
                            <TableHead className="text-right">
                                Quantity
                            </TableHead>
                            <TableHead className="text-right">
                                Discount
                            </TableHead>
                            <TableHead className="text-right">
                                Sub Total
                            </TableHead>
                            <TableHead className="text-right">Total</TableHead>
                            <TableHead className="text-right">
                                Actions
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>{renderItems()}</TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

CartItems.displayName = 'CartItems';
